<section>
  <div class="flex flex-col gap-[0.5rem]">
    <div class="flex flex-row justify-between items-center">
      <app-tabs-with-counter
        data-qa="kpi-metrics-main-tabs"
        [initialTabIndex]="tabs.selectedIndex"
        [tabNamesRaw]="tabs.all"
        (selectedTabEmitter)="switchTab($event)"
        [type]="TabType.Grey"
      />
      <app-ai-button
        data-qa="kpi-ai-modal-button"
        (buttonClick)="openAi()">
        <div class="flex items-center gap-0.3125 pr-2">
          <div>Orca AI</div>
          <div class="relative">
            <div class="beta">BETA</div>
          </div>
        </div>
      </app-ai-button>
    </div>
    <router-outlet/>
  </div>
</section>

@if (showAiModal) {
  <app-kpi-ai-modal (closeEmitter)="showAiModal=false"/>
}
